export default function () {
	const $info_panel = $('.info-panel');
	if (!$info_panel.length) {
		return;
	}

	const self = {};

	const _private = {
		handleCartUpdate: function (e, response) {
			if (response.data && response.data.error) {
				self.show(response.data.error);
			}
		},

		handleCartAdd: function (e, response) {
			if (response.status === 'ok') {
				return;
			}

			if (response.status === 'fail') {
				self.show(response.errors);
			}
		},

		handleMailerSubscribe: function () {
			self.show('Спасибо за подписку!');
		},

		bindEvents: function () {
			$info_panel.find('.info-panel__close-button').on('click', () => {
				self.hide();
			});
		},

		bindGlobalEvents: function () {
			$(document).on('shop_cart_add', this.handleCartAdd);
			$(document).on('shop_cart_update', this.handleCartUpdate);
			$(document).on('mailer_subscribe', this.handleMailerSubscribe);
		}
	};

	$.extend(self, {
		show: function (message) {
			this.hide();

			$info_panel.find('.info-panel__message').html(message);
			$info_panel.addClass('info-panel_visible');

			setTimeout(this.hide, 3000);
		},

		hide: function () {
			$info_panel.removeClass('info-panel_visible');
		}
	});

	_private.bindEvents();
	_private.bindGlobalEvents();

	return self;
}
